const MODULE_NAME = 'hirekService';
class HirekService {
	constructor($http, environment, $q) {
		'ngInject';
		this._$http = $http;
		this._$q = $q;
		this._apiRoot = $http({
			url: `${environment.backendUrl}/do/proxy/b`
		});
	}
	getKategoriak() {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('hirKategoriak');
		}).then((resp) => {
			return resp.$hasEmbedded('newsCategories') ? resp.$request().$get('newsCategories') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	getCimkek(size) {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('cimkekTop', { page: 0, size: size || 10 });
		}).then((resp) => {
			return resp.$hasEmbedded('cimkek') ? resp.$request().$get('cimkek') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	get(id) {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('hir', { hirId: id });
		}, () => {
			return this._$q.reject();
		});

	}
	lista(model, type) {
		let searchQueryPagePromise = this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get(type, model);
		}, () => {
			return this._$q.reject();
		});
		let searchQueryPromise = searchQueryPagePromise.then((resp) => {
			return resp.$hasEmbedded('hirek') ? resp.$request().$get('hirek') : [];
		}, () => {
			return this._$q.reject();
		});
		return this._$q.all([searchQueryPagePromise, searchQueryPromise]);
	}
}

export default angular.module(MODULE_NAME, [])
	.service('hirekService', HirekService).name;



// WEBPACK FOOTER //
// ./source/applications/hirek/hirek-service.js